export const TAXFORMS_ACTION_TYPE = {
	formInformation:"formInformation",
	taxPayerForm:"taxPayerForm",
	taxPayerFormIdle:"taxPayerFormIdle",
	taxPayerFormData:"taxPayerFormData",
	forms:"forms",
	formCreated:"formCreated",
	formDeleted:"formDeleted",
};
